import { Navigate } from 'react-router-dom';
import { isLoginArea } from '../utils';
import { isTwoAuthenticateEnabled } from '../utils/sessionStorageHelpers';

function PrivateRouteLavoratore({ children, requireTwoFactor = false }) {
    const logok = isLoginArea('lavoratore');

    if (!logok) {
        return <Navigate to="/AreaLavoratore/Login" />;
    }

    if (requireTwoFactor && !isTwoAuthenticateEnabled()) {
        return (
            <Navigate
                to="/AreaLavoratore/Home"
                replace
                state={{ mfaRequired: true }}
            />
        );
    }

    return children;
}

export default PrivateRouteLavoratore;
